<template>
  <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%">
    <div class="el-table__body-wrapper is-scrolling-none">
      <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
        <colgroup>
          <col width="180" />
          <col />
        </colgroup>
        <tbody>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>发票类型</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">
                <span v-if="!invoice.isVatSpecial && invoice.isElectronic">增值税普通发票（数电）</span>
                <span v-else-if="invoice.isVatSpecial && invoice.isElectronic">增值税专用发票（数电）</span>
                <span v-else-if="!invoice.isVatSpecial && !invoice.isElectronic">增值税普通发票（纸质）</span>
                <span v-else-if="invoice.isVatSpecial && !invoice.isElectronic">增值税专用发票（纸质）</span>
              </div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>发票抬头</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">{{ invoice.taxTitle }}</div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>纳税人识别号</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">
                {{ invoice.taxNo }}
              </div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>申请时间</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">
                {{ invoice.createdDate }}
              </div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>状态</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">
                {{ getInvoiceStatus(invoice.status) }}
              </div>
            </td>
          </tr>
          <template v-if="invoice.isVatSpecial">
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>注册地址</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">{{ invoice.taxAddress }}</div>
              </td>
            </tr>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>电话</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">
                  {{ invoice.taxTel }}
                </div>
              </td>
            </tr>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>开户银行</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">
                  {{ invoice.taxBankName }}
                </div>
              </td>
            </tr>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>银行帐号</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">
                  {{ invoice.taxBankNo }}
                </div>
              </td>
            </tr>
          </template>
          <template v-if="invoice.isElectronic">
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>电子邮箱</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">
                  {{ invoice.email }}
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>收件人姓名</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">
                  {{ invoice.deliveryName }}
                </div>
              </td>
            </tr>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>收件人电话</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">
                  {{ invoice.deliveryTel }}
                </div>
              </td>
            </tr>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>快递地址</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">
                  {{ invoice.deliveryAddress }}
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="el-table__column-resize-proxy" style="display: none"></div>
  </div>
</template>

<script lang="ts">
import { IInvoice } from '@/types/models';
import { defineComponent, PropType } from 'vue';

const $statusInvoiceDefault = 'Default';
const $statusInvoiceDelivered = 'Delivered';
const $statusInvoiceCancellation = 'Cancellation';

export default defineComponent({
  props: {
    invoice: {
      type: Object as PropType<IInvoice>,
      required: true,
    },
  },
  methods: {
    getInvoiceStatus(status: string) {
      if (status === $statusInvoiceDefault) {
        return '待开发票';
      }
      if (status === $statusInvoiceDelivered) {
        return '已开发票';
      }
      if (status === $statusInvoiceCancellation) {
        return '作废发票';
      }
      return '待开发票';
    },
  },
});
</script>
